import { OfferRecord, SiteLocale } from 'apps/website/types/dato';
import { FirstPayrollOfferProps } from '../../types';
import { linkResolver } from 'apps/website/src/utils/linkResolver';
import { mergePrices } from '../mergePrices';
import { mapperPricingRanges } from './mapperPricingRanges';

export const mapperFirstPayrollOffer = ({
  offer,
  locale,
}: {
  offer: OfferRecord;
  locale: SiteLocale;
}): FirstPayrollOfferProps | undefined => {
  if (!offer.associatedFirstPayrollOffer) {
    return;
  }
  const firstPayrollOffer = offer.associatedFirstPayrollOffer;
  let link = firstPayrollOffer.link?.externalLink as string | undefined;
  if (firstPayrollOffer.link?.internalLink) {
    link = linkResolver(
      firstPayrollOffer.link.internalLink,
      locale,
      firstPayrollOffer.link.urlParams,
    );
  }
  let linkOnDemand = firstPayrollOffer.linkOnDemand?.externalLink as
    | string
    | undefined;
  if (firstPayrollOffer.linkOnDemand?.internalLink) {
    linkOnDemand = linkResolver(
      firstPayrollOffer.linkOnDemand.internalLink,
      locale,
      firstPayrollOffer.linkOnDemand.urlParams,
    );
  }

  const firstPayrollOfferMapped: FirstPayrollOfferProps = {
    id: firstPayrollOffer.id,
    __typename: 'DatoCmsFirstPayrollOffer',
    highlightedLabel: firstPayrollOffer.highlightedLabel,
    featuresSections: firstPayrollOffer.featuresSections,
    title: firstPayrollOffer.title || undefined,
    isFirstPayroll: true,
    link: link,
    linkOnDemand: linkOnDemand,
    tag: firstPayrollOffer.tag || undefined,
    icon: 'firstPayroll',
    banner: firstPayrollOffer.banner || undefined,
    pricingRange: firstPayrollOffer.pricingRange.map((price) => ({
      base: price.base,
      price: price.price,
      obFees: price.obFees,
      from: price.from,
    })),
    labels: firstPayrollOffer.labels,
    activeFreeMonths: firstPayrollOffer.activeFreeMonths,
  };

  const pricingRangeWithDiscount = mergePrices(
    mapperPricingRanges(offer?.pricingRange),
    firstPayrollOfferMapped.pricingRange,
  );

  return {
    ...firstPayrollOfferMapped,
    title: firstPayrollOfferMapped.title || undefined,
    pricingRange: pricingRangeWithDiscount,
  };
};
